export default "__VITE_ASSET__ec1f572a__"